import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9 pt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-5" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Informasi Umum Pesanan")
], -1)
const _hoisted_6 = { class: "row mb-5" }
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-12 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Sekolah", -1)
const _hoisted_11 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<hr><div class=\"row mb-5\"><h6>Informasi Proses Cetak Kartu</h6></div><div class=\"row mb-5\"><div class=\"col-lg-6 fv-row\"></div></div><hr><div class=\"row mb-5\"><h6>Pengiriman</h6></div><div class=\"row mb-5\"><div class=\"col-lg-6 fv-row\"></div></div>", 6)
const _hoisted_20 = { class: "card-footer d-flex justify-content-end py-6 px-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Form, {
                id: "kt_account_profile_details_form",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveNpwp()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "name",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Nama Sekolah",
                        modelValue: _ctx.detail.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.detail.name) = $event))
                      }, null, 8, ["modelValue"]),
                      (_ctx.detail.name == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.items.errorschoolName), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13))
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_14
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          class: "btn btn-primary me-3",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/superadmin/data-product')))
        }, " Kembali ")
      ])
    ])
  ], 64))
}